import BlankButton from '@xo-union/component-blank-button';
import { DATA_SOURCES } from '@xo-union/tk-component-vendor-typeahead';
import React, { Fragment } from 'react';

import styles from './typeaheadFooter.scss';

interface Props {
  // @ts-ignore
  source: DATA_SOURCES.LOCAL | DATA_SOURCES.GOOGLE;
  switchSource: Function;
  allowCustomVendor: boolean;
}

const TypeaheadFooter: React.FC<Props> = ({ source, switchSource, allowCustomVendor }) => (
  <div className={styles.container}>
    <div className={styles.description}>Can&apos;t find your Vendor?</div>
    <div>
      {source === DATA_SOURCES.LOCAL && (
        // @ts-ignore
        <BlankButton onClick={(e): void => switchSource(e, DATA_SOURCES.GOOGLE)}>Search Google</BlankButton>
      )}
      {source === DATA_SOURCES.GOOGLE && (
        // @ts-ignore
        <BlankButton onClick={(e): void => switchSource(e, DATA_SOURCES.LOCAL)}>The Knot Results</BlankButton>
      )}
      {allowCustomVendor && (
        <Fragment>
          <span> or </span>
          <BlankButton
            onClick={
              // @ts-ignore
              (e): void => switchSource(e, 'custom')
            }
          >
            Add Custom Vendor
          </BlankButton>
        </Fragment>
      )}
    </div>
  </div>
);

export default TypeaheadFooter;
